import * as React from "react"

export default function ReactionGestureSolidIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 5.482l3.585-3.783.996 1.05c.996.07 3.187.421 3.983 1.262.797.84.598 1.75.399 2.101l4.412 2.416a.7.7 0 01.271.96l-.672 1.178a.7.7 0 01-.942.268l-3.468-1.88 2.63 3.38a.7.7 0 01-.104.967l-.864.72c-.343.285-.869.187-1.129-.175-.872-1.216-2.33-2.729-2.724-3.421-.908.958-3.122.909-3.983 0-1.115-1.177-1.261-3.012-1.195-3.783L1 5.482z"
        fill={props.fill}
      />
    </svg>
  )
}
